export const getQuery = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get('token');
    const env = params.get('env');
    const view = params.get('view');

    return { token, env, view }
}